<script setup lang="ts">
interface SpinnerProps {
  active?: boolean
  size?: string
  color?: string
}

withDefaults(defineProps<SpinnerProps>(), {
  active: true,
  size: 'sm',
  color: 'white',
})
</script>

<template>
  <div class="spinner-container">
    <div
      class="spinner ant-spin ant-spin-spinning"
      :class="[{ active }, size]"
      :style="{ color }"
    >
      <i
        aria-label="icon: loading" class="anticon anticon-loading ant-spin-dot"
      ><svg
        viewBox="0 0 1024 1024"
        data-icon="loading"
        width="1em"
        height="1em"
        fill="currentColor"
        aria-hidden="true"
        focusable="false"
        class="anticon-spin"
      >
        <path
          d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 0 0-94.3-139.9 437.71 437.71 0 0 0-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"
        /></svg></i>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.ant-spin {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: 'tnum';
  position: absolute;
  display: none;
  color: white;
  text-align: center;
  vertical-align: middle;
  opacity: 0;
  transition: transform 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);

  // transform: translate(-50%, -50%);

  &.ant-spin-spinning {
    position: static;
    display: inline-block;
    opacity: 1;
  }

  &.active {
    opacity: 1;
    display: block;
  }

  i {

    &.anticon {
      display: inline-block;
      color: inherit;
      font-style: normal;
      line-height: 0;
      text-align: center;
      text-transform: none;
      vertical-align: -0.125em;
      text-rendering: optimizeLegibility;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }

    &.ant-spin-dot {
      position: relative;
      display: inline-block;
    }

    svg {
      fill: var(--c-sky-blue);
      &.anticon-spin {
        animation: loadingCircle 1s linear infinite;
      }
    }

    @keyframes loadingCircle {
      to {
        transform: rotate(1turn);
      }
    }
  }

  &.sm {
    i {
      font-size: 20px;
      width: 1em;
      height: 1em;
    }
  }

  &.md {
    i {
      font-size: 24px;
      width: 1.25rem;
      height: 1.25rem;
    }
  }
  &.lg {
    i {
      font-size: 40px;
      width: 1.75rem;
      height: 1.75rem;

      svg {
        
      }
    }
  }
}
</style>
